import { render, staticRenderFns } from "./FaturamentoPrincipaisClienteVendas3.vue?vue&type=template&id=2f0c7cfe&scoped=true&"
import script from "./FaturamentoPrincipaisClienteVendas3.vue?vue&type=script&lang=js&"
export * from "./FaturamentoPrincipaisClienteVendas3.vue?vue&type=script&lang=js&"
import style0 from "./FaturamentoPrincipaisClienteVendas3.vue?vue&type=style&index=0&id=2f0c7cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c7cfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
